module.exports = __webpack_public_path__ + "img/file--------sns--------------------@1x.b673128b.png";